module.exports = __webpack_public_path__ + "media/images/btn_stallion_regs-156ebbf0cfbf8df3d41070f7254d2c9b.gif";